// extracted by mini-css-extract-plugin
export default {"oosPopoverWrapper":"Dp-z","slideIn":"Ep-z"};